import { CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STORE_FILTER_TEXT } from "./constants";

interface StoreFilterStatusBarProps {
  totalCount: number;
  selectedCount: number;
  allSelected: boolean;
  onToggleAll: () => void;
}

/** "{total} lojas · {selecionadas} selecionadas" + ação selecionar/desmarcar todas. */
export function StoreFilterStatusBar({
  totalCount,
  selectedCount,
  allSelected,
  onToggleAll,
}: StoreFilterStatusBarProps) {
  return (
    <div className="flex items-center justify-between">
      <p className="text-xs text-muted-foreground">
        {totalCount} lojas · {selectedCount} selecionadas
      </p>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 px-2 text-xs"
        disabled={totalCount === 0}
        onClick={onToggleAll}
      >
        <CheckCheck className="mr-1 h-3.5 w-3.5" />
        {allSelected ? STORE_FILTER_TEXT.unselectAll : STORE_FILTER_TEXT.selectAll}
      </Button>
    </div>
  );
}
